import React, { useEffect, useState, useCallback } from 'react';
import { GoSearch } from 'react-icons/go';
import { useDispatch } from 'react-redux';
import { setSearchQuery } from '../store/slice/searchSlice';
import { debounce } from 'lodash';

const Navbar = () => {
  const dispatch = useDispatch();
  const [searchInput, setSearchInput] = useState('');

  const debouncedSearch = useCallback(
    debounce(value => {
      dispatch(setSearchQuery(value));
    }, 500),
    [dispatch]
  );

  const handleSearchChange = e => {
    const value = e.target.value;
    setSearchInput(value);
    debouncedSearch(value);
  };

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  return (
    <nav className="sticky top-0 left-64 w-[80%] h-[72px] bg-white z-50 font-nohemi">
      <div className="py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center justify-start">
            <form className="mx-2" onSubmit={e => e.preventDefault()}>
              <label
                htmlFor="default-search"
                className="mb-2 text-sm font-medium text-[#4A5154] sr-only">
                Search
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 flex items-center pointer-events-none start-0 ps-3">
                  <GoSearch />
                </div>
                <input
                  type="search"
                  id="default-search"
                  className="block w-96 h-[40px] p-4 ps-10 text-xs text-[#959FA3] rounded-[4px] bg-[#F2F3F4] focus:outline-none focus:ring-0"
                  placeholder="Search"
                  value={searchInput}
                  onChange={handleSearchChange}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
